import React from "react";
import { useTranslation, Trans } from "react-i18next";

export const ProjectManagementDescriptionSection = () => {
  const { t } = useTranslation();

  return (
    <section className="description-section">
      <div>
        <h1>{t("project.header")}</h1>
        <p>{t("project.text_1")}</p>
      </div>
      <div className="list-container">
        <p>{t("project.text_2")}</p>
        <p>
          <ul className="list">
            <li>
              <Trans t={t} i18nKey="project.list.item_1" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_2" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_3" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_4" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_5" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_6" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_7" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_8" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_9" />
            </li>
            <li>
              <Trans t={t} i18nKey="project.list.item_10" />
            </li>
          </ul>
        </p>

        <p>{t("project.text_3")}</p>
      </div>
      <div>
        <p>
          <b>{t("project.text_4")}</b>
        </p>
        <br />
        <p>{t("project.text_5")}</p>
      </div>
    </section>
  );
};
